import { OnInit } from '@angular/core';
import { AssetService } from 'app/library-assets/services/asset.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'app/login/services/auth.service';
import { AlertService } from 'app/shared/services/alert.service';
var TakeAssetExternalComponent = /** @class */ (function () {
    function TakeAssetExternalComponent(authService, assetService, route, router, alertService) {
        var _this = this;
        this.authService = authService;
        this.assetService = assetService;
        this.route = route;
        this.router = router;
        this.alertService = alertService;
        this.authService.getCurrentClient().then(function (client) {
            _this._client = client;
            // not sure I like this nested, but it does handle duplicate requests for the uid.
            _this.route.params.subscribe(function (params) {
                var assetId = +params['assetId'];
                _this.getAssetResult(client, assetId).then(function (assetResult) {
                    if (assetResult) {
                        _this.navigateToAssetResultForClient(client, assetId, assetResult);
                    }
                    else {
                        _this.loadAsset(assetId);
                    }
                }).catch(function (error) {
                    console.error(error);
                    _this.loadAsset(assetId);
                });
            });
        });
    }
    TakeAssetExternalComponent.prototype.navigateToAssetResultForClient = function (client, assetId, assetResult) {
        this.router.navigate(['assessments', client.id, 'asset-result', assetResult.id]);
    };
    TakeAssetExternalComponent.prototype.getAssetResult = function (client, assetId) {
        var assignment = client.findAssignmentItemForAssetId(assetId);
        if (assignment && assignment.IsComplete) {
            // grab our result id
            return this.assetService.getAssetResult(assignment.ResultId);
        }
        else {
            return Promise.resolve(null); // return nothing.
        }
    };
    TakeAssetExternalComponent.prototype.loadAsset = function (assetId) {
        var _this = this;
        this.assetService.getAsset(assetId).then(function (asset) {
            _this._loading = false;
            _this._asset = asset;
        })
            .catch(function (response) {
            _this._loading = false;
            _this.alertService.error("Failed to load.  Please check your network connection or contact customer support");
            console.error(response);
        });
    };
    Object.defineProperty(TakeAssetExternalComponent.prototype, "loading", {
        get: function () {
            return this._loading;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TakeAssetExternalComponent.prototype, "asset", {
        get: function () {
            return this._asset;
        },
        enumerable: true,
        configurable: true
    });
    TakeAssetExternalComponent.prototype.ngOnInit = function () {
    };
    TakeAssetExternalComponent.prototype.shouldDisplayExercise = function () {
        return this._asset && this._asset.type == 'assignment';
    };
    TakeAssetExternalComponent.prototype.shouldDisplayArticle = function () {
        return this._asset && this._asset.type == 'article';
    };
    TakeAssetExternalComponent.prototype.submitAsset = function (assetResult) {
        var _this = this;
        // create the exercise results
        this.saving = true;
        // grab all the answers
        var savingMsg = this.alertService.info("Saving....", 600000);
        this.assetService.saveAssetResult(assetResult).then(function (savedAssetResult) {
            _this.alertService.success("Saved answers for " + savedAssetResult.asset.title);
            _this.alertService.clearAlert(savingMsg);
            _this.navigateToAssetResultForClient(_this._client, savedAssetResult.asset.id, savedAssetResult);
        })
            .catch(function (error) {
            _this.alertService.clearAlert(savingMsg);
            console.error("Failed to save json result", error);
            _this.saving = false;
            _this.alertService.error("There was an error in saving your assignment. Please check your internet connection or try again. If you continue to have problems please contact us via our contact page.", 5000);
        });
    };
    return TakeAssetExternalComponent;
}());
export { TakeAssetExternalComponent };



// WEBPACK FOOTER //
// ./src/app/assessments/take-asset-external/take-asset-external.component.ts.pre-build-optimizer.js